export * from './Home/Home'
export * from './PrivacyPolicy';
export * from './TermsAndConditions';
export * from './Account';
export * from './UnderReview/UnderReview';
export * from './Register/Register';
export * from './Register/RegisterStepTwo';